import React, { useState } from 'react';
import { 
  Card, 
  CardContent, 
  Typography, 
  Button, 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  Box,
  CircularProgress
} from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import SendIcon from '@mui/icons-material/Send';
import { uploadFile } from '../services/api';

const FileUploadForm = ({ operations, selectedOperation, onOperationChange, onUploadSuccess }) => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!file) {
      setError('Por favor seleccione un archivo');
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      await uploadFile(file, selectedOperation);
      setFile(null);
      if (onUploadSuccess) onUploadSuccess();
    } catch (error) {
      console.error("Error al subir archivo:", error);
      setError('Error al subir el archivo');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Typography variant="h6" component="div" gutterBottom>
          Subir Archivo para Procesamiento
        </Typography>
        
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
          <Box sx={{ mb: 2 }}>
            <Button
              variant="outlined"
              component="label"
              startIcon={<UploadFileIcon />}
              fullWidth
              sx={{ height: '56px', justifyContent: 'flex-start' }}
            >
              {file ? file.name : 'Seleccionar Archivo'}
              <input
                type="file"
                hidden
                onChange={handleFileChange}
                accept=".txt,.md,.json"
              />
            </Button>
          </Box>
          
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel id="operation-select-label">Operación</InputLabel>
            <Select
              labelId="operation-select-label"
              id="operation-select"
              value={selectedOperation}
              label="Operación"
              onChange={(e) => onOperationChange(e.target.value)}
              disabled={loading}
            >
              {operations.map((op) => (
                <MenuItem key={op.name} value={op.name}>
                  {op.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          
          <Button 
            type="submit" 
            variant="contained" 
            color="primary" 
            fullWidth
            disabled={!file || loading}
            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
          >
            {loading ? 'Subiendo...' : 'Subir y Procesar'}
          </Button>
          
          {error && (
            <Typography color="error" sx={{ mt: 2, textAlign: 'center' }}>
              {error}
            </Typography>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default FileUploadForm; 